export const FE_BASE_URL: string = (process.env.REACT_APP_FE_BASE_URL as string) || '';
export const BE_BASE_URL: string = (process.env.REACT_APP_BE_BASE_URL as string) || '';
export const COOKIE_DOMAIN: string = (process.env.REACT_APP_COOKIE_DOMAIN as string) || '';
export const COOKIE_MAX_AGE: string = (process.env.REACT_APP_COOKIE_MAX_AGE as string) || '0';
export const BE_COMPANY_ENDPOINT: string = '/company/';
export const BE_COURSES_ENDPOINT: string = '/courses/';
// Il catalogo si chiama senza slash finale: il backend non accetta la variante con slash
export const BE_COURSE_CATALOG_ENDPOINT: string = '/courses';
export const BE_DATES_ENDPOINT: string = '/dates/';
export const BE_EMPLOYEE_ENDPOINT: string = '/employee/';
export const BE_RESERVATION_ENDPOINT: string = '/reservation/';
export const BE_CERTIFICATES_ENDPOINT: string = '/certificates';
// Più attestati in un archivio zip, preparato dal backend: un solo download invece di una
// raffica che il browser ostacola.
export const BE_CERTIFICATES_ZIP_ENDPOINT: string = '/certificates/zip';
export const BE_DASHBOARD_SUMMARY_ENDPOINT: string = '/dashboard/summary';
export const BE_TEMPLATE_DOWNLOAD_ENDPOINT: string = '/employee/download';
export const BE_IMPORT_EMPLOYEES_ENDPOINT: string = '/employee';
export const BE_EMPLOYEE_LIMIT_REACHED_ENDPOINT: string = '/employee/limit-reached';
// Importazione guidata dei dipendenti: si consegna il foglio e si conversa sull'esito,
// invece di ricevere un elenco di scarti in prosa dentro un alert.
export const BE_IMPORT_CHAT_ENDPOINT: string = '/employee/excel/chat';
// Attributi per integrazione documentale FORMA1
export const ATTESTATO_DOC_TYPE_ID: number =
  +(process.env.REACT_APP_ATTESTATO_DOC_TYPE_ID as string) || 0;
// Timeout del client HTTP, in millisecondi.
// Senza un valore esplicito axios attende all'infinito: una richiesta che si perde lascia lo
// spinner acceso per sempre e la pagina sembra bloccata (ticket Odoo 291).
export const HTTP_TIMEOUT_MS: number = 30_000;
// Il caricamento degli attestati passa dall'estrazione dei metadati, che e' legittimamente lenta:
// il backend concede a DocuManager fino a 300 secondi. Qui il limite e' piu' basso di proposito,
// perche' oltre i tre minuti l'operatore ha gia' concluso che la pagina non risponde.
export const HTTP_TIMEOUT_CARICAMENTO_MS: number = 180_000;

export const SEMPREFORMATI_LANDING_URL: string = (process.env.REACT_APP_SEMPREFORMATI_LANDING_URL as string) || ''
